/**
 * Hypnia Kids
 */

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

window.addEventListener('DOMContentLoaded', (event) => {

  const hypniaKidsStatusElement = document.querySelector('[data-hypnia-kids-status]');
  let hypniaKidsStatus = hypniaKidsStatusElement.getAttribute('data-hypnia-kids-status');
  let cookieHypniaKids = getCookie('hypnia_kids');

  // === Add/remove Kids Colors if kids Cookie

  function addOrRemoveKidsColors(cookieHypniaKids) {

    if (cookieHypniaKids === 'true') {
      document.documentElement.setAttribute('data-hypnia-kids', 'active')
    } else {
      document.documentElement.setAttribute('data-hypnia-kids', 'disabled')
    }

  }

  addOrRemoveKidsColors(cookieHypniaKids);

  // === Show/hide if kids Cookie

  function showOrHideKidsElements(cookieHypniaKids) {
    const elementsKidsOnly = document.querySelectorAll('[data-kids-only]');
    const elementsKidsNone = document.querySelectorAll('[data-kids-none]');

    if (cookieHypniaKids === 'true') {
      if (elementsKidsOnly.length > 0) {
        elementsKidsOnly.forEach(elementKidsOnly => {
          elementKidsOnly.style.display = 'block'
        });
      }
      if (elementsKidsNone.length > 0) {
        elementsKidsNone.forEach(elementKidsNone => {
          elementKidsNone.style.display = 'none'
        });
      }
    } else {
      if (elementsKidsOnly.length > 0) {
        elementsKidsOnly.forEach(elementKidsOnly => {
          elementKidsOnly.style.display = 'none'
        });
      }
      if (elementsKidsNone.length > 0) {
        elementsKidsNone.forEach(elementKidsNone => {
          elementKidsNone.style.display = 'block'
        });
      }
    }

    if (hypniaKidsStatus !== 'ready') {
      hypniaKidsStatusElement.setAttribute('data-hypnia-kids-status', 'ready')
    }

    const eventKidsReady = new Event("kids-ready");
    document.dispatchEvent(eventKidsReady);
  }

  showOrHideKidsElements(cookieHypniaKids);
  
  // === Enable Kids

  function kidsEnable() {
    setCookie('hypnia_kids', 'true', 15);
  }

  const kidsEnableTriggers = document.querySelectorAll('[data-kids-enable-trigger]');
  if (kidsEnableTriggers.length > 0) {
    kidsEnableTriggers.forEach(kidsEnableTrigger => {
      kidsEnableTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        kidsEnable();

        // If is link: redirect after
        const this_link_href = kidsEnableTrigger.getAttribute('href');
        if (this_link_href !== null && this_link_href !== undefined) {
          window.location.href = this_link_href;
        } else {
          cookieHypniaKids = getCookie('hypnia_kids');
          addOrRemoveKidsColors(cookieHypniaKids);
          showOrHideKidsElements(cookieHypniaKids);
        }
      });
    });
  }

  // === Disable Kids

  function kidsDisable() {
    setCookie('hypnia_kids', '', -1000);
  }

  const kidsDisableTriggers = document.querySelectorAll('[data-kids-disable-trigger]');
  if (kidsDisableTriggers.length > 0) {
    kidsDisableTriggers.forEach(kidsDisableTrigger => {
      kidsDisableTrigger.addEventListener('click', (e) => {
        e.preventDefault();

        kidsDisable();

        window.location.href = '/';
      });
    });
  }
  
});